import { graphql } from "react-relay";

export const FREE_TEXT_SELF_CHECK_ELEMENT_FRAGMENT = graphql`
	fragment freeTextSelfCheckElementForm_FreeTextSelfCheckElementFragment on FreeTextSelfCheckElement {
		id
		title
		text
		enableSolutionReveal
		solutionText
	}
`;

export const EDIT_FREE_TEXT_SELF_CHECK_ELEMENT_MUTATION = graphql`
	mutation freeTextSelfCheckElementForm_EditFreeTextSelfCheckElementMutation(
		$input: EditFreeTextSelfCheckElementInput!
	) {
		Admin {
			ElearningV2 {
				editFreeTextSelfCheckElement(input: $input) {
					freeTextSelfCheckElement {
						...freeTextSelfCheckElementForm_FreeTextSelfCheckElementFragment
					}
				}
			}
		}
	}
`;
